import { css } from 'styled-system/css'

export type CommunityTopic = 'finance' | 'reset' | 'health'

export const TOPICS: Record<CommunityTopic, { label: string; color: string }> = {
	finance: { label: 'Finance', color: '#2f79e0' },
	reset: { label: 'Reset', color: '#8257e6' },
	health: { label: 'Health', color: '#0ea5a4' },
}

export const TOPIC_KEYS = Object.keys(TOPICS) as CommunityTopic[]

export const pill = (active: boolean) => css({
	borderWidth: '1px',
	borderStyle: 'solid',
	borderColor: active
		? 'color-mix(in srgb, var(--colors-editorial-accent) 55%, transparent)'
		: 'var(--colors-editorial-hair-strong)',
	bg: active
		? 'color-mix(in srgb, var(--colors-editorial-accent) 12%, var(--colors-editorial-panel))'
		: 'transparent',
	color: active ? 'editorialInk' : 'editorialInk2',
	fontWeight: '600',
	fontSize: '12px',
	h: '32px',
	px: '13px',
	borderRadius: '999px',
	cursor: 'pointer',
	whiteSpace: 'nowrap',
	transition: 'border-color 0.15s, color 0.15s, background 0.15s',
	...(active ? {} : {
		_hover: {
			color: 'editorialInk',
		},
	}),
})
